import React, { useMemo } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { Link as MuiLink } from '@mui/material';

type MuiLinkProps = Omit<Parameters<typeof MuiLink>[0], 'component' | 'href'>;

type Props = {
  href: string;
  replace?: boolean;
  backLinkHref?: string;
} & MuiLinkProps;

const Link = React.forwardRef<HTMLAnchorElement, Props>(function Link({ href, backLinkHref, ...props }, ref) {
  const state = useMemo(() => {
    if (typeof backLinkHref !== 'string') {
      return undefined;
    }
    return { backLinkHref };
  }, [backLinkHref]);
  return <MuiLink ref={ref} component={RouterLink} to={href} href={href} state={state} {...props} />;
});

export default Link;
